import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const myDetailsRoute: RouteConfig<'with-page'> = {
    name: 'My Details',
    context: 'member',
    path: '/myaccount/details',
    page: lazy(() => import('.')),
    flags: ['member-route'],
}